import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
import { FiArrowRight, FiGrid, FiMaximize } from 'react-icons/fi';
import './Lookbook.css';

const Lookbook = () => {
  const [activeCollection, setActiveCollection] = useState('ss26');

  const collections = [
    {
      id: 'ss26',
      name: 'Spring/Summer 2026',
      title: 'Between Light & Shadow',
      description: 'Our Spring/Summer 2026 collection explores the tension between structure and fluidity. Clean architectural silhouettes meet soft draping in a palette that moves from deep charcoal to luminous white, punctuated by electric blue moments.',
      story: 'Inspired by brutalist architecture and the play of natural light across concrete surfaces, each piece tells a story of contrast — bold yet understated, minimal yet deeply considered.',
      image: '/images/lookbook-bg.svg',
      pieces: [
        {
          id: 1,
          name: 'Architectural Wool Coat',
          designer: 'Aetheris',
          image: '/images/tee-1.svg'
        },
        {
          id: 2,
          name: 'Concrete Silk Dress',
          designer: 'Caspian',
          image: '/images/tee-2.svg'
        },
        {
          id: 3,
          name: 'Brutalist Shoulder Bag',
          designer: 'Valaure',
          image: '/images/tee-3.svg'
        },
        {
          id: 4,
          name: 'Shadow Leather Boots',
          designer: 'Maison Noir',
          image: '/images/tee-4.svg'
        }
      ]
    },
    {
      id: 'aw25',
      name: 'Autumn/Winter 2025',
      title: 'Monochrome Reverie',
      description: 'A study in contrasts, our Autumn/Winter collection embraces the duality of light and dark. Rich textures and layered silhouettes create depth within a restrained palette.',
      story: 'Drawing from the quiet intensity of Nordic winters and the warmth of interior spaces, this collection balances protective outerwear with intimate layers.',
      image: '/images/lookbook-bg.svg',
      pieces: [
        {
          id: 5,
          name: 'Cashmere Overcoat',
          designer: 'Aetheris',
          image: '/images/tee-1.svg'
        },
        {
          id: 6,
          name: 'Merino Turtleneck',
          designer: 'Caspian',
          image: '/images/tee-2.svg'
        }
      ]
    }
  ];

  const activeCollectionData = collections.find(c => c.id === activeCollection);

  return (
    <div className="lookbook-page">
      {/* Hero Section */}
      <section className="lookbook-hero">
        <div className="lookbook-hero-background">
          <img 
            src={activeCollectionData.image} 
            alt={activeCollectionData.title}
            className="lookbook-hero-image"
          />
          <div className="lookbook-hero-overlay"></div>
        </div>
        
        <div className="lookbook-hero-content">
          <div className="lookbook-tag">{activeCollectionData.name}</div>
          <h1 className="lookbook-hero-title">
            {activeCollectionData.title}
          </h1>
          <p className="lookbook-hero-description">
            {activeCollectionData.description}
          </p>
          <div className="lookbook-hero-actions">
            <button className="lookbook-btn primary">
              EXPLORE COLLECTION
              <FiArrowRight />
            </button>
            <button className="lookbook-btn secondary">
              <FiGrid />
              VIEW ALL
            </button>
          </div>
        </div>
      </section>

      {/* Collection Navigation */}
      <section className="collection-nav">
        <div className="container">
          <div className="collection-nav-items">
            {collections.map((collection) => (
              <button
                key={collection.id}
                className={`collection-nav-btn ${activeCollection === collection.id ? 'active' : ''}`}
                onClick={() => setActiveCollection(collection.id)}
              >
                <span className="collection-name">{collection.name}</span>
                <span className="collection-title">{collection.title}</span>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* The Story */}
      <section className="lookbook-story">
        <div className="container">
          <div className="story-grid">
            <div className="story-content">
              <div className="story-subtitle">The Story</div>
              <h2 className="story-title">{activeCollectionData.title}</h2>
              <p className="story-description">
                {activeCollectionData.story}
              </p>
              <div className="story-divider"></div>
              <div className="story-meta">
                <div className="meta-item">
                  <span className="meta-label">Collection</span>
                  <span className="meta-value">{activeCollectionData.name}</span>
                </div>
                <div className="meta-item">
                  <span className="meta-label">Pieces</span>
                  <span className="meta-value">{activeCollectionData.pieces.length}</span>
                </div>
              </div>
            </div>
            <div className="story-image">
              <img 
                src="/images/tee-3.svg" 
                alt="Lookbook story"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Collection Grid */}
      <section className="collection-grid-section">
        <div className="container">
          <div className="grid-header">
            <h2 className="grid-title">Editorial</h2>
            <p className="grid-subtitle">Select pieces from the collection</p>
          </div>
          
          <div className="collection-grid">
            {activeCollectionData.pieces.map((piece, index) => (
              <div 
                key={piece.id} 
                className={`grid-item ${index === 0 ? 'featured' : ''}`}
              >
                <div className="grid-image-container">
                  <img src={piece.image} alt={piece.name} />
                  <div className="grid-overlay">
                    <button className="grid-view-btn">
                      <FiMaximize />
                    </button>
                  </div>
                </div>
                <div className="grid-item-info">
                  <span className="grid-item-designer">{piece.designer}</span>
                  <h3 className="grid-item-name">{piece.name}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Campaign Film Section */}
      <section className="campaign-film">
        <div className="film-background">
          <div className="film-overlay"></div>
          <div className="film-content">
            <span className="film-tag">Campaign Film</span>
            <h2 className="film-title">The Making of</h2>
            <p className="film-description">
              An intimate look behind the scenes of our Spring/Summer 2026 campaign.
            </p>
            <button className="film-btn">
              WATCH FILM
              <FiArrowRight />
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Lookbook;